// Copyright (C) 2025 Skylark Drones

import { v1EventGatewayInstance } from '@/config'
import { getAgoraChannelUid } from '@/utils/common'

/**
 * Give command to the dock to perform a action
 *
 * @param {String} commandKey dock command key
 * @returns
 */
export function callCommand(dockSn, commandKey, payload) {
  return v1EventGatewayInstance.http.post(
    `docks/${dockSn}/services/command/${commandKey}`,
    { [commandKey]: payload }
  )
}

export function getDockLivestreamToken(dockSn, { role, uid, channelName }) {
  return v1EventGatewayInstance.http.get(`docks/${dockSn}/livestreams/token`, {
    params: { role, uid: getAgoraChannelUid(uid), channel_name: channelName }
  })
}

export function updateDeviceProperty(dockSn, payload) {
  return v1EventGatewayInstance.http.post(`docks/${dockSn}/properties`, payload)
}
